import { render, staticRenderFns } from "./OrdenarDocumentosJuntar.vue?vue&type=template&id=2befbff8"
import script from "./OrdenarDocumentosJuntar.vue?vue&type=script&lang=js"
export * from "./OrdenarDocumentosJuntar.vue?vue&type=script&lang=js"
import style0 from "./OrdenarDocumentosJuntar.vue?vue&type=style&index=0&id=2befbff8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports